module.exports = __webpack_public_path__ + "img/frame2.cd955314.jpg";